import React, { useContext, useEffect, useState } from 'react'
import working from '../media/images/working.png'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthProvider'

const Layout = () => {
  const [mon, setMon] = useState()
  const {
    user,
    setUser,
    isLogged,
  } = useContext(AuthContext)

  const navigate = useNavigate()


  useEffect(() => {
    if (!isLogged) {
      navigate('/')
    }
  }, [isLogged])
  const fetchData = async () => {
    try {
      const response = await fetch('https://xgramm.com/xgramm_backend/admin/monChecker.php', {
        method: 'Post',
        headers: {
          'Content-Type': 'application/json',
          },
          body: JSON.stringify({user})
      })
      const results = await response.json()
      setMon(results.Monetazation[0])
    } catch (error) {
      console.error('Monetazation Error:', error)
    }
  }
  useEffect(() => {
    fetchData()
  }, [])

  const handleActivate = async () => {
    try {
      const response = await fetch('https://xgramm.com/xgramm_backend/admin/monModify.php', {
        method: 'Post',
        headers: {
          'Content-Type': 'application/json',
          },
          body: JSON.stringify({type: 'Activate'})
      })
      const results = await response.json()
      fetchData()
    } catch (error) {
      console.error('Action Error:', error)
    }

  }
  const handleDeactivate = async () => {
    try {
      const response = await fetch('https://xgramm.com/xgramm_backend/admin/monModify.php', {
        method: 'Post',
        headers: {
          'Content-Type': 'application/json',
          },
          body: JSON.stringify({type: 'Deactivate'})
      })
      const results = await response.json()
      fetchData()
    } catch (error) {
      console.error('Action Error:', error)
    }
  }
  return (
    <div style={{position: 'relative'}} className='w3-col l9 w3-right m9 s12 main'>
        <div className="w3-container">
            <div className="w3-left flex-row w3-padding-24">
            <p className="w3-text-purple">
              Monetization
            </p>
            <p className="w3-small padding-sm">
              <i class="fa-solid fa-angles-right"></i>
            </p>
            <p className="text-dark">Admin</p>
            </div>
        </div>
        <div className="w3-container grid-center">
          <div className="w3-panel w3-white w3-round-large w3-card">
              <div className="w3-row w3-padding flex-row j-space">
                <p className="w3-large margin-0">{mon && mon.status == 'Active' ? 'Deactivate Monetazation' : 'Activate Monetazation'}</p>
                {mon && mon.status == 'Active' ? <button className='btn btn-danger w3-margin' onClick={handleDeactivate}>Deactivate</button> : <button className='btn btn-primary w3-margin' onClick={handleActivate}>Activate</button>}
                
              </div>
          </div>
        </div>
    </div>
  )
}

export default Layout